import React from 'react';
import { LI } from '../../../core-components/li';
import { Link } from '../../../core-components/link';
import { UL } from '../../../core-components/ul';
import { Box, BoxProps } from '../../../next-components/box';
import { Typography } from '../../Typography';
export type RelatedArticle = {
  title: string;
  src: string;
};
export type AuthorRelatedArticlesProps = Omit<BoxProps, 'value'> & {
  value: {
    name: string;
    articles: RelatedArticle[];
  };
};
export const AuthorRelatedArticles = ({
  value: {
    name,
    articles
  },
  ...rest
}: AuthorRelatedArticlesProps) => <Box display="grid" gridTemplateColumns={['72px 1fr']} gridGap="16px" {...rest} data-sentry-element="Box" data-sentry-component="AuthorRelatedArticles" data-sentry-source-file="AuthorRelatedArticles.tsx">
    <Box width="1px" height="100%" border="1px solid #979797" mx="auto" data-sentry-element="Box" data-sentry-source-file="AuthorRelatedArticles.tsx" />
    <Box data-sentry-element="Box" data-sentry-source-file="AuthorRelatedArticles.tsx">
      <Typography m={0} fontSize="14px" fontWeight="bold" textTransform="uppercase" data-sentry-element="Typography" data-sentry-source-file="AuthorRelatedArticles.tsx">
        {`More articles by ${name}`}
      </Typography>
      <UL p={0} my="16px" style={{
      listStyleType: 'none'
    }} data-sentry-element="UL" data-sentry-source-file="AuthorRelatedArticles.tsx">
        {articles.map(article => <LI key={article.title} py="8px">
            <Link href={article.src} fontSize="16px" fontWeight="bold" color="wagGreen" fontFamily="muli">
              {article.title}
            </Link>
          </LI>)}
      </UL>
    </Box>
  </Box>;